// this file is automatically generated by git.revision.js script
export const versions = { revision: '54bf3f74cb' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '54bf3f74cb';
